import { ApiRequest } from "src/models/api.request";
import VwOrganizasyonYetkiDTO from "src/models/Base/Yetki/VwOrganizasyonYetkiDTO";
import VwGnlOrganizasyonDTO from "src/models/Settings/Generals/VwGnlOrganizasyonDTO";
import api from "src/services/core/api";

const controllerName = "VwOrganizasyonYetkiDTO";
export const organizasyonApi = api.injectEndpoints({
  endpoints: builder => ({
    getOrganizasyonByKullanici: builder.query<Array<VwOrganizasyonYetkiDTO>, number>({
      query: (kullaniciId) => {
        const request: ApiRequest<VwOrganizasyonYetkiDTO> = {
          filters: {
            groupOperator: "and",
            predicates: [
              { fieldName: "kullaniciId", operator: "=", value1: kullaniciId },
            ],
          },
          paging: false,
          sorts: [
            { fieldName: "fkOrganizasyon" }
          ]
        }
        return {
          url: controllerName + "/find",
          method: "POST",
          body: JSON.stringify(request)
        }
      },
      providesTags: ["OrganizasyonKullanici"]
    }),
    OrganizasyonBirimeGoreGetir: builder.query<Array<VwGnlOrganizasyonDTO>, void>({
      query: () => {
        let api: ApiRequest<VwGnlOrganizasyonDTO> = {
          paging: false,
          filters: {
            groupOperator: "and",
            predicates: [
              { fieldName: "tipId", operator: "=", value1: 2 },
            ],
          },
          sorts: [
            { fieldName: "id", ascending: false },
          ],
        };
        return {
          url: "VwGnlOrganizasyonDTO/find",
          method: "POST",
          body: JSON.stringify(api),
        };
      },
    }),
  }),
})

export const { useGetOrganizasyonByKullaniciQuery, useOrganizasyonBirimeGoreGetirQuery, } = organizasyonApi;